import Cookies from "js-cookie";
import React, { Fragment } from "react";
import { Outlet, Navigate } from "react-router";

const ProtectedRoutes = ({ children }) => {
  const isAuthenticated = Cookies.get("jwt_token");

  if (!isAuthenticated) {
    return <Navigate to={"/"} replace />;
  }
  return <Fragment>{ children ? children : <Outlet />}</Fragment>;


     
};

export default ProtectedRoutes;